import React, { useEffect } from 'react';
import { Box, Modal } from '@mui/material';
import { modalStyle } from '../modalStyle';
import AddPaymentMethod from './AddPaymentMethod';
import { usePaymentMethodStore } from '../../../stores';

interface AddPaymentMethodModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export default function AddPaymentMethodModal({ isOpen, onCancel, onSave }: AddPaymentMethodModalProps) {
  const createMethodIntent = usePaymentMethodStore.use.createMethodIntent();
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  useEffect(() => {
    if (isOpen) {
      createMethodIntent().then(() => setModalIsOpen(isOpen));
    }
  }, [isOpen]);

  const handleCancel = () => {
    setModalIsOpen(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleSave = () => {
    setModalIsOpen(false);
    if (onSave) {
      onSave();
    }
  };

  return (
    <Modal open={modalIsOpen} onClose={onCancel}>
      <Box sx={{ ...modalStyle }}>
        <AddPaymentMethod onSave={handleSave} onCancel={handleCancel} />
      </Box>
    </Modal>
  );
}
